import React from 'react'
import '../phone/Phones.css'
const PageNotFound = () => {
  return (
    <div className='pagenotfound'>
        <img src="https://www.artzstudio.com/content/images/wordpress/2020/05/404-error-not-found-page-lost.png" alt="" />
    </div>
  )
}

export default PageNotFound